var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnboardingGroupController = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _useLocation = require("./useLocation");
var _useCar = require("./useCar");
var _useAviation = require("./useAviation");
var _useDiet = require("./useDiet");
var _useHouse = require("./useHouse");
var _useGoal = require("./useGoal");
var _usePerson2 = require("./usePerson");
var _useStep = require("./useStep");
var _excluded = ["person", "isLoading"];
var source = 'estimated';
var globalId = 'null';
var OnboardingGroupController = exports.OnboardingGroupController = (0, _createClass2["default"])(function OnboardingGroupController() {
  var _this = this;
  (0, _classCallCheck2["default"])(this, OnboardingGroupController);
  (0, _defineProperty2["default"])(this, "useController", function () {
    var _usePerson = (0, _usePerson2.usePerson)(),
      person = _usePerson.person,
      isLoading = _usePerson.isLoading,
      extraPersonProps = (0, _objectWithoutProperties2["default"])(_usePerson, _excluded);
    var props = {
      source: source,
      globalId: globalId,
      person: person
    };
    var location = (0, _useLocation.useLocation)(props);
    var car = (0, _useCar.useCar)(props);
    var aviation = (0, _useAviation.useAviation)(props);
    var diet = (0, _useDiet.useDiet)(props);
    var house = (0, _useHouse.useHouse)(props);
    var goal = (0, _useGoal.useGoal)();
    var step = (0, _useStep.useStep)();
    return Object.assign({
      isLoading: isLoading,
      person: person
    }, extraPersonProps, {
      globalId: globalId
    }, _this, location, car, aviation, diet, house, goal, step);
  });
});